"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidationStatus = exports.CheckoutStoreAddresses = void 0;
exports.CheckoutStoreAddresses = {
    Billing: 'billingAddress',
    Shipping: 'shippingAddress',
};
exports.AddressValidationStatus = {
    Verified: 'verified',
    Suggestion: 'suggestion',
    Error: 'error',
};
